export { default } from './FAQBlock';
export * from './FAQBlock';
